export default __webpack_public_path__ + "static/section-why-us-1-f22b0202dad9a0ffd6b623e125a381be.jpg";